/* eslint-disable import/no-cycle */
import {
  getMuseVariantFromEvent,
  getVariantsWithQuantityForSpecificShop,
} from './apiRequest';
import { serializeFormToJSON } from './html';
import { logger } from './logger';
import {
  delayIfNeededUtils,
  getCountryCodeUtils,
  getCurrencyRateUtils,
  getCurrencyUtils,
  getLocaleUtils,
  getPageUtils,
  getShopUtils,
  getThemeUtils,
  getUTMDataUtils,
  isCartPageUtils,
  isDraftThemeUtils,
  isInaEssUtils,
  isShopifyThemeEditorUtils,
  removeArrowDiscountUtils,
  resetDataUtils,
  setUTMDataUtils,
  storeUTMDataUtils,
} from '../index-utils';

export function getShop() {
  return getShopUtils();
}

export function isShopifyThemeEditor() {
  return isShopifyThemeEditorUtils();
}

export function getPage() {
  return getPageUtils();
}

export function getTheme() {
  return getThemeUtils();
}

export function getCurrency() {
  return getCurrencyUtils();
}

export function getCountryCode() {
  return getCountryCodeUtils();
}

export function getLocale() {
  return getLocaleUtils();
}

export function getCurrencyRate() {
  return getCurrencyRateUtils();
}

export function isDraftTheme() {
  return isDraftThemeUtils();
}

export function getDevice() {
  let check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  if (check) {
    return 'mobile';
  }
  return 'web';
}

export function getProductHandleFromURL() {
  const pageURL = window.location.href;
  const querySplit = pageURL.split('?');
  const product_split = querySplit[0].split('/products/');
  if (product_split.length === 2) {
    return product_split[1];
  }
  return '';
}

export function getVariantIDFromTarget(target) {
  // getProductPropertiesFromTarget(target);
  const closestForm = target.closest('form');
  if (!closestForm) {
    // doesn't have a form this store
    if (getShop() === 'selvrys-store.myshopify.com') {
      const variantElements = document.getElementsByName('id');
      for (const variantElement of variantElements) {
        if (variantElement.value) {
          return variantElement.value;
        }
      }
    }
    return null;
  }
  const idElement = closestForm.querySelector('[name="id"],[name="id[]"]');
  if (!idElement) {
    return null;
  }
  const variantId = idElement.value;
  if (!Number.isNaN(Number(variantId))) {
    return variantId;
  }
  return null;
}

export function getSelectedVariantIdFromURL() {
  const variantIdMatch = window.location.search.match(
    /.*variant=([^&|\n|\t\s]+)/,
  );
  if (variantIdMatch) {
    return variantIdMatch[1];
  }
  return 0;
}

export function getDefaultProductVariant(product) {
  if (product) {
    if (product.variants) {
      if (product.variants.length > 0) {
        return product.variants[0].id;
      }
    }
  }
  return null;
}

export function getProductPropertiesFromForm(closestForm) {
  logger.log('closest form', !!closestForm);
  // using it instead of logger function to avoid cyclic dependency
  if (!closestForm) {
    return {};
  }

  const formData = serializeFormToJSON(closestForm);
  const { properties } = formData;
  if (properties) {
    return properties;
  }
  return {};
}

export function getProductPropertiesFromTarget(target) {
  const closestForm = target.closest('form');
  return getProductPropertiesFromForm(closestForm);
}

export function getVariantsWithQuantityFromForm(
  closestForm,
  isSellingPlanEnabled,
) {
  try {
    const formdata = new FormData(closestForm);
    const formJSON = {};
    formdata.forEach((value, key) => {
      if (!Reflect.has(formJSON, key)) {
        formJSON[key] = value;
        return [];
      }
      if (!Array.isArray(formJSON[key])) {
        formJSON[key] = [formJSON[key]];
      }
      formJSON[key].push(value);
    });

    // no id
    if (!Reflect.has(formJSON, 'id')) {
      return [];
    }

    let ids = formJSON['id'];
    if (!Array.isArray(ids)) {
      ids = [ids];
    }
    const selling_plan = formJSON.selling_plan || null;

    let quantities = formJSON['quantity'];
    if (!quantities) {
      quantities = [];
      for (let i = 0; i < ids.length; i++) {
        quantities = quantities.concat(i > 0 ? 0 : 1);
      }
    } else {
      if (!Array.isArray(quantities)) {
        quantities = [quantities];
      }
    }

    const properties = getProductPropertiesFromForm(closestForm);
    const variantsWithQuantity = ids.reduce((items, item, idx) => {
      if (Number(quantities[idx]) > 0) {
        const itemData = {
          sp_variant_id: Number(item),
          quantity: Number(quantities[idx]),
        };
        if (properties) {
          itemData['properties'] = properties;
        }
        if (isSellingPlanEnabled && selling_plan)
          itemData.selling_plan = selling_plan;
        return items.concat(itemData);
      }
      return items;
    }, []);

    return variantsWithQuantity;
  } catch (e) {
    return [];
  }
}

export function getVariantsWithQuantityFromEvent(event, isSellingPlanEnabled) {
  const { target } = event;
  try {
    if (
      [
        'at-tempo.myshopify.com',
        'shoptikidemo.myshopify.com',
        'yoga-studio-store.myshopify.com',
        'd97dc6.myshopify.com',
        'car-touchup-paint.myshopify.com',
      ].includes(getShop())
    ) {
      const specificVariantsWithQuantity = getVariantsWithQuantityForSpecificShop(
        {
          target,
        },
      );
      if (specificVariantsWithQuantity.length > 0) {
        return specificVariantsWithQuantity;
      }
    }

    let closestForm = target.closest('form');
    if (!closestForm) {
      // doesn't have a form this store
      if (getShop() === 'selvrys-store.myshopify.com') {
        const variantElements = document.getElementsByName('id');
        for (const variantElement of variantElements) {
          if (variantElement.value) {
            return [
              { sp_variant_id: Number(variantElement.value), quantity: 1 },
            ];
          }
        }
      }

      if (getShop() === 'muse-india.myshopify.com') {
        const variantID = getMuseVariantFromEvent(event);

        if (variantID) {
          return [{ sp_variant_id: Number(variantID), quantity: 1 }];
        }
      }

      if (getShop() === 'theodinvediko.myshopify.com') {
        const variantID = target.getAttribute('data-id');
        if (variantID) {
          return [{ sp_variant_id: Number(variantID), quantity: 1 }];
        }
      }

      if (
        [
          'bluetyga.myshopify.com',
          'kalaonlineshaz.myshopify.com',
          'longevitybox.myshopify.com',
          'drocto.myshopify.com',
        ].includes(getShop())
      ) {
        closestForm = document.querySelector("form[action$='/cart/add']");
      }

      // try getting from closest button
      const closestButton = target.closest('button');
      if (closestButton) {
        const { dataset } = closestButton;
        if (dataset) {
          const { variantId } = dataset;
          if (variantId) {
            return [{ sp_variant_id: Number(variantId), quantity: 1 }];
          }
        }
      }

      if (getShop() === 'hydropeptidedev.myshopify.com') {
        if (closestButton) {
          const { nextElementSibling } = closestButton;
          if (nextElementSibling && nextElementSibling.tagName === 'FORM') {
            closestForm = nextElementSibling;
          }
        }
      }

      if (window.ShopifyAnalytics) {
        if (window.ShopifyAnalytics.meta) {
          if (window.ShopifyAnalytics.meta.selectedVariantId) {
            const id = parseInt(
              window.ShopifyAnalytics.meta.selectedVariantId,
              10,
            );

            if (!Number.isNaN(id)) {
              return [{ sp_variant_id: id, quantity: 1 }];
            }
          }
        }
      }
      if (!closestForm) {
        return [];
      }
    }
    const variantsWithQuantity = getVariantsWithQuantityFromForm(
      closestForm,
      isSellingPlanEnabled,
    );
    if (
      variantsWithQuantity.length === 0 &&
      getShop() === 'little-baby-grains.myshopify.com'
    ) {
      const variants = getVariantsFromProductPage();
      if (variants && variants.length > 0) {
        return [{ sp_variant_id: variants[0].id, quantity: 1 }];
      }
    }
    return variantsWithQuantity;
  } catch (e) {
    return [];
  }
}

export function getIsSellingPlanEnabled(target) {
  if (getShop() === 'orderflow-labs.myshopify.com') {
    return false;
  }

  if (getShop() === 'byron-moonshine-coffee.myshopify.com') {
    return false;
  }

  if (isInaEss()) {
    return false;
  }

  const closestForm = target.closest('form');
  if (!closestForm) {
    return false;
  }
  const sellingPlanElement = closestForm.querySelector(
    '[name="selling_plan"],[name="selling_plan[]"],[name="properties[group_id]"]',
  );

  if (sellingPlanElement) {
    const val = Number(sellingPlanElement.value);
    if (!Number.isNaN(val) && val > 0) {
      logger.log('offer disabled for selling plans', sellingPlanElement.value);
      // using it instead of logger function to avoid cyclic dependency
      return true;
    }
  }

  return false;
}

export function getEmbeddedTrigger({ source }) {
  const isProductPage = source === 'product_page';
  return isProductPage ? 'prp' : 'cp';
}

export function isCartPage() {
  return isCartPageUtils();
}

export function isLovintan() {
  return [
    'australialovingtan.myshopify.com',
    'loving-tan.myshopify.com',
    'loving-tan-uk.myshopify.com',
    'loving-tan-ca.myshopify.com',
    'auslovingtan.myshopify.com',
    'loving-tan-eu.myshopify.com',
  ].includes(getShop());
}

export function isInaEss() {
  return isInaEssUtils();
}

export function isMorocanOil() {
  return [
    'moroccanoil-admin.myshopify.com',
    'moil-de.myshopify.com',
    'moil-uk.myshopify.com',
    'moil-il.myshopify.com',
    'moroccanoil-ca.myshopify.com',
    'moroccanoil-admin-dev.myshopify.com',
  ].includes(getShop());
}

export function isOlliella() {
  return [
    'olliella-eu.myshopify.com',
    'olliella-au.myshopify.com',
    'olliella-us.myshopify.com',
    'olliella.myshopify.com',
  ].includes(getShop());
}

export async function delayIfNeeded() {
  await delayIfNeededUtils();
}

// resetData ... a function to reset any configs or data that could have been set
export function resetData() {
  resetDataUtils();
}

export function removeArrowDiscount() {
  removeArrowDiscountUtils();
}

export async function storeUTMData() {
  storeUTMDataUtils();
}

export function getCityAndCounty() {
  const city = localStorage.getItem('city');
  const county = localStorage.getItem('county');
  return { city, county };
}

export function getUTMData() {
  getUTMDataUtils();
}

export function setUTMData(data) {
  setUTMDataUtils(data);
}

// isSendCartJS ...
export function isSendCartJS() {
  // if (window.isZecpeInstalled) return true;
  if (isArrowInstalled()) return true;
  if (isMagicInstalled()) return true;
  return false;
}

export function isArrowInstalled() {
  return !!window.arrow_checkout_clicked;
}

export function isMagicInstalled() {
  if (window.RazorpayMagicCheckout) {
    return window.RazorpayMagicCheckout.isMagicEnabled();
  }
  return false;
}

export function getShopfloSessionID() {
  if (window.Shopflo && window.Shopflo.getSessionId) {
    return window.Shopflo.getSessionId();
  }
  return '';
}

export function getVariantsFromProductPage() {
  const {
    ShopifyAnalytics: {
      meta: {
        product: { variants },
      },
    },
  } = window;

  return variants;
}
